import {
  AddOutlined,
  Check,
  CheckOutlined,
  Close,
  DeleteOutline,
  Edit,
  EditNote,
  EditOutlined,
  FolderOutlined,
  FolderSpecialOutlined,
  FolderSpecialTwoTone,
  FolderTwoTone,
  KeyboardArrowDown,
  KeyboardArrowRight,
} from "@mui/icons-material";
import {
  Box,
  IconButton,
  InputAdornment,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Popover,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { Tree, NodeApi } from "react-arborist";
import { font } from "../../styles/font";
import { useApplicationContext } from "../../context/ApplicationContext";
import AutoSizer from "react-virtualized-auto-sizer";
import { LightTooltip } from "../styled/CustomComponent";
import {
  Entity,
  FolderType,
  ModulePath,
  Severity,
} from "../../constant/ApplicationVariables";
import { useLocation } from "react-router-dom";
import { HttpStatusCode } from "axios";
import { updateModule_API } from "../../api/controller/ModuleController";
import useErrorHandler from "../../api/errorHandler/useErrorHandler";
import { useTranslation } from "react-i18next";
import { debounce } from "../../utils/Functions";
import {
  updateDeleteRelease_API,
  updateDeleteSprint_API,
} from "../../api/controller/PlanningController";
import { updateDeleteTestSet_API } from "../../api/controller/ExecutionController";
import { TiTickOutline } from "react-icons/ti";
import { memo } from "react";
import { forwardRef } from "react";
import { useImperativeHandle } from "react";
import TemplateLoaderComponent from "../loader/TemplateLoaderComponent"; // Add this import
import { getSingleStory_API } from "../../api/controller/StoryController";
import { getSingleUseCase_API } from "../../api/controller/UseCaseController";
import { getSingleTestCase_API } from "../../api/controller/TestCaseController";
import { TestCaseCustomIcon, UseCaseCustomIcon, UserStoryCustomIcon } from "../styled/CustomIcons";

const Treeview = forwardRef(
  ({ dataList, loading: propsLoading = false }, ref) => {
    // Accept loading prop
    const {
      treeRef,
      currentFolderData,
      setCurrentFolderData,
      activeProject,
      isUpdateFolderStructure,
      setIsUpdateFolderStructure,
      setIsUpdateCurrentFolderData,
      handleSnackbar,
      newFolderLocation,
      setNewFolderLocation,
      folderSearchTerm,
      setFolderSearchTerm,
    } = useApplicationContext();
    const errorHandler = useErrorHandler();
    const pathName = useLocation()?.pathname;

    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [list, setList] = useState([]);

    console.log(dataList, "dataList");

    // Use propsLoading or internal loading state
    const isLoading = propsLoading || loading;

    // Helper to update node data
    function updateNode(nodes, id, newData) {
      return nodes.map((node) => {
        if (node.id === id) return { ...node, ...newData };
        if (node.children)
          return { ...node, children: updateNode(node.children, id, newData) };
        return node;
      });
    }

    useImperativeHandle(ref, () => ({
      createInlineFolder: (atRoot = false) => {
        if (!treeRef.current) return;

        const parentNode = atRoot
          ? null
          : treeRef.current.get(currentFolderData?.id);
        const tempId = `temp-${Date.now()}`;
        const newFolder = {
          id: tempId,
          name: `New Folder_${list?.length + 1}`,
          children: [],
          isTemp: true,
        };

        // 1. Optimistic UI update
        treeRef.current.create({
          parentId: parentNode,
          index: list?.length || 0,
          data: newFolder,
        });

        if (parentNode && !parentNode.isOpen) {
          parentNode.open();
        }

        // 2. Focus and edit
        setTimeout(() => {
          const newNode = treeRef.current?.get(tempId);
          if (newNode) {
            newNode.edit();
          }
        }, 50);
      },
    }));

    const openNode = (id) => {
      if (treeRef.current) {
        treeRef.current.open(id);
      }
    };

    const handleChangeSearchTerm = debounce((e) => {
      setFolderSearchTerm(e.target.value);
    }, 300);

    const onRename = ({ id, name, node }) => {
      let response = false;

      console.log(id, name, node, "nodeeditonrename");

      if (
        pathName === ModulePath.planning &&
        node?.data?.type?.toLowerCase() === Entity.release?.toLowerCase()
      ) {
        response = handleUpdateRelease(id, name, node);
      } else if (
        pathName === ModulePath.planning &&
        node?.data?.type?.toLowerCase() === Entity.sprint?.toLowerCase()
      ) {
        response = handleUpdateSprint(id, name, node);
      } else if (
        pathName === ModulePath.execution &&
        node?.data?.type?.toLowerCase() === Entity.testSet?.toLowerCase()
      ) {
        response = handleUpdateTestSet(id, name, node);
      } else {
        response = handleUpdateModule(id, name, node);
      }

      // 3. Update tree data
      setList((prev) => updateNode(prev, id, response));

      // 4. Refocus the renamed node
      setTimeout(() => {
        treeRef.current?.focus(id);
      }, 0);

      return response;
    };

    const scrollToNode = (folderId) => {
      if (treeRef.current) {
        console.log(
          folderId,
          "newFolderLocation currentfolderdata id scroll open newFolderLocationnn treeref",
          treeRef.current,
          treeRef.current.get(folderId),
        );

        let array = [];
        let dataObject = treeRef.current.get(folderId);

        while (dataObject?.level > 0) {
          dataObject = dataObject?.parent;
          console.log(dataObject, "while__ dataObjectt");
          array.push(dataObject);
        }

        console.info(array, "array__dataobjectt before reverse");
        array.reverse(); // Reverse the array to open from root to leaf
        console.info(array, "array__dataobjectt after reverse");

        array.forEach((nodeItem, i) => {
          console.info(nodeItem, "nodeItemmm dataobjectt for opening");
          if (!nodeItem.id) return;
          treeRef.current.open(nodeItem?.id);
        });

        if (!folderId) return;
        treeRef.current.scrollTo(folderId, { align: "auto" });
      }
    };

    const handleUpdateModule = async (id, name, node) => {
      try {
        if (name === "") return;
        if (name === currentFolderData?.name) {
          return;
        }

        let body = {
          projectName: activeProject?.name,
          currentName: currentFolderData?.name,
          newName: name,
          section:
            pathName === ModulePath.requirements
              ? Entity.userStory
              : pathName === ModulePath.useCase
                ? Entity.useCase
                : Entity.testCase,
          path: currentFolderData?.path,
          delete: false,
          lastModifiedAt: currentFolderData?.lastModifiedAt
            ? currentFolderData?.lastModifiedAt
            : null,
        };

        if (currentFolderData?.name === name) {
          delete body.newName;
        }

        const response = await updateModule_API(body);
        console.log(response.response, "response handleUpdateModule");

        if (response) {
          errorHandler(response?.response ? response.response : response);
        }

        if (response.status === HttpStatusCode.Ok) {

          setIsUpdateFolderStructure(true);
          setIsUpdateCurrentFolderData(true);

          return response.data;

          if (body?.newName) {
            if (body.path.includes("/")) {
              let folderPathList = body.path.split("/");
              folderPathList.pop(); // Remove the last part
              let result = folderPathList.join("/");

              setNewFolderLocation(`${result}/${body?.newName}`);
            } else {
              setNewFolderLocation(`${body?.newName}`);
            }
          } else {
            setNewFolderLocation(
              body?.path ? `${body?.path}` : `${body?.name}`,
            );
          }

          scrollToNode(currentFolderData?.id);
        }
      } catch (error) {
        console.log(error, error?.message, "projectreponse errorr");
        handleSnackbar(String(error), Severity.error);
        return false;
      } finally {
        setTimeout(() => {
          setLoading(false);
        }, 100);
      }
    };

    const handleUpdateRelease = async (id, name, node) => {
      try {
        setLoading(true);

        if (name === "") return;
        if (name === currentFolderData?.name) {
          return;
        }

        let body = {
          newName: name,
          name: currentFolderData?.name,
          lastModifiedAt: currentFolderData?.lastModifiedAt
            ? currentFolderData?.lastModifiedAt
            : null,
          projectName: activeProject?.name,
        };

        if (currentFolderData?.name === name) {
          delete body.newName;
        }

        const response = await updateDeleteRelease_API(body);
        console.log(response.response, "response handleUpdateModule");

        if (response) {
          errorHandler(
            response?.response ? response.response : response,
            setLoading,
          );
        }

        if (response.status === HttpStatusCode.Ok) {
          setIsUpdateFolderStructure(true);
          setIsUpdateCurrentFolderData(true);

          if (body?.newName) {
            setNewFolderLocation(`${body?.newName}`);
          } else {
            setNewFolderLocation(
              body?.path ? `${body?.path}` : `${body?.name}`,
            );
          }

          scrollToNode(currentFolderData?.id);
        }
      } catch (error) {
        console.log(error, error?.message, "projectreponse errorr");
        handleSnackbar(String(error), Severity.error);
      } finally {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      }
    };

    const handleUpdateSprint = async (id, name, node) => {
      try {
        setLoading(true);

        if (name === "") return;
        if (name === currentFolderData?.name) {
          return;
        }

        let body = {
          newName: name,
          name: currentFolderData?.name,
          lastModifiedAt: currentFolderData?.lastModifiedAt
            ? currentFolderData?.lastModifiedAt
            : null,
          projectName: activeProject?.name,
          releaseName: currentFolderData?.releaseName,
        };

        if (currentFolderData?.name === name) {
          delete body.newName;
        }

        const response = await updateDeleteSprint_API(body);
        console.log(response.response, "response handleUpdateModule");

        if (response) {
          errorHandler(
            response?.response ? response.response : response,
            setLoading,
          );
        }

        if (response.status === HttpStatusCode.Ok) {
          setIsUpdateFolderStructure(true);
          setIsUpdateCurrentFolderData(true);

          if (body?.newName) {
            setNewFolderLocation(
              body?.releaseName
                ? `${body?.releaseName}/${body?.newName}`
                : `${body?.newName}`,
            );
          } else {
            setNewFolderLocation(
              body?.path ? `${body?.path}` : `${body?.name}`,
            );
          }

          scrollToNode(currentFolderData?.id);
        }
      } catch (error) {
        console.log(error, error?.message, "projectreponse errorr");
        handleSnackbar(String(error), Severity.error);
      } finally {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      }
    };

    const handleUpdateTestSet = async (id, name, node) => {
      try {
        setLoading(true);

        if (name === "") return;
        if (name === currentFolderData?.name) {
          return;
        }

        let body = {
          newName: name,
          name: currentFolderData?.name,
          lastModifiedAt: currentFolderData?.lastModifiedAt
            ? currentFolderData?.lastModifiedAt
            : null,
          projectName: activeProject?.name,
          releaseName: currentFolderData?.releaseName,
        };

        if (currentFolderData?.name === name) {
          delete body.newName;
        }

        const response = await updateDeleteTestSet_API(body);
        console.log(response.response, "response handleUpdateModule");

        if (response) {
          errorHandler(
            response?.response ? response.response : response,
            setLoading,
          );
        }

        if (response.status === HttpStatusCode.Ok) {
          setIsUpdateFolderStructure(true);
          setIsUpdateCurrentFolderData(true);
          setCurrentFolderData(node?.data);

          if (body?.newName) {
            setNewFolderLocation(
              body?.releaseName
                ? `${body?.releaseName}/${body?.newName}`
                : `${body?.newName}`,
            );
          } else {
            setNewFolderLocation(
              body?.path ? `${body?.path}` : `${body?.name}`,
            );
          }

          scrollToNode(currentFolderData?.id);
        }
      } catch (error) {
        console.log(error, error?.message, "projectreponse errorr");
        handleSnackbar(String(error), Severity.error);
      } finally {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      }
    };

    // show the folder in tree , when folder changes
    useEffect(() => {
      if (
        currentFolderData?.id &&
        treeRef.current &&
        !isUpdateFolderStructure
      ) {
        scrollToNode(currentFolderData?.id);
        console.log(
          currentFolderData,
          treeRef.current.get(currentFolderData?.id),
          "function called",
        );
      }
    }, [currentFolderData?.id, treeRef.current, isUpdateFolderStructure]);

    useEffect(() => {
      setList(dataList);
    }, [dataList]);

    return (
      <Box
        className="flex flex-col flex-1 gap-4 w-full relative"
        onContextMenu={(e) => e.preventDefault()}
      >
        {/* Show loader when loading */}
        {isLoading && (
          <TemplateLoaderComponent
            minimal={true}
            // or minimal={false} for the full version
          />
        )}

        <Box className="flex-1 flex flex-col">
          <AutoSizer>
            {({ height, width }) => {
              console.log(height, width, "heightwidth");
              return (
                <Tree
                  data={list}
                  openByDefault={false}
                  width={width}
                  height={height}
                  indent={24}
                  rowHeight={32}
                  onRename={onRename}
                  searchTerm={folderSearchTerm}
                  searchMatch={(node, term) =>
                    node.data.name.toLowerCase().includes(term.toLowerCase())
                  }
                >
                  {({ node, style, dragHandle }) => (
                    <Box>
                      <Node
                        node={node}
                        style={style}
                        dragHandle={dragHandle}
                        treeRef={treeRef}
                      />
                    </Box>
                  )}
                </Tree>
              );
            }}
          </AutoSizer>
        </Box>
      </Box>
    );
  },
);

export default memo(Treeview);

// In your Node component (from Treeview.js or similar)
export const Node = memo(({ node, style, dragHandle }) => {
  const {
    currentFolderData,
    setCurrentFolderData,
    openEditUseCaseDialog,
    setOpenEditUseCaseDialog,
    openEditStoryDialog,
    setOpenEditStoryDialog,
    currentFolderAnchorCoordinates,
    setCurrentFolderAnchorCoordinates,
    handleSnackbar,
    currentAIEntityData,
    activeProject,
    setCurrentUserStoryData,
    setCurrentUseCaseData,
  } = useApplicationContext();

  const theme = useTheme();
  const pathName = useLocation()?.pathname;
  const { t } = useTranslation("translation", { keyPrefix: "sidebar.folder" });

  const isDarkMode = theme.palette.mode === "dark";

  const isActive =
    currentFolderData?.id?.toLowerCase() === node?.id?.toLowerCase();

  // Get the appropriate count based on the current module
  const getItemCount = () => {
    if (pathName === ModulePath.requirements) {
      return `[${node?.data?.count?.self}|${node?.data?.count?.total}]` || 0;
    } else if (pathName === ModulePath.useCase) {
      return `[${node?.data?.count?.self}|${node?.data?.count?.total}]` || 0;
    } else if (pathName === ModulePath.testCase) {
      return `[${node?.data?.count?.self}|${node?.data?.count?.total}]` || 0;
    } else if (pathName === ModulePath.planning) {
      // For planning, show release/sprint specific counts if available
      if (node?.data?.type?.toLowerCase() === Entity.release?.toLowerCase()) {
        return node?.data?.sprintCount || node?.data?.testPlanCount || 0;
      } else if (
        node?.data?.type?.toLowerCase() === Entity.sprint?.toLowerCase()
      ) {
        return node?.data?.testPlanCount || 0;
      }
      return 0;
    } else if (pathName === ModulePath.execution) {
      // For execution, show test set specific counts
      if (node?.data?.type?.toLowerCase() === Entity.release?.toLowerCase()) {
        return node?.data?.testSetCount || 0;
      } else if (
        node?.data?.type?.toLowerCase() === Entity.testSet?.toLowerCase()
      ) {
        return node?.data?.testCaseCount || 0;
      }
      return 0;
    }
    return 0;
  };

  // Get the appropriate text color for the count (ALWAYS visible)
  const getCountTextColor = () => {
    const count = getItemCount();

    // When active, always use a color that contrasts with the active background
    if (isActive) {
      return "hsl(var(--accent-foreground))"; // This should be a contrasting color
    }

    // When not active, use module-specific colors
    if (count === 0) {
      return "hsl(var(--muted-foreground))";
    }

    if (pathName === ModulePath.requirements) {
      return theme.palette.primary.main;
    } else if (pathName === ModulePath.useCase) {
      return theme.palette.primary.main;
    } else if (
      pathName === ModulePath.testCase ||
      pathName === ModulePath.execution
    ) {
      return theme.palette.primary.main;
    } else if (pathName === ModulePath.planning) {
      return theme.palette.primary.main;
    }

    return theme.palette.text.secondary;
  };

  const handleFolderClick = async (folder) => {
    try {
      const { type, customId, folderPath } = folder.data;

      const entityMap = {
        [Entity.userStory]: {
          api: getSingleStory_API,
          setData: setCurrentUserStoryData,
          openDialog: () => setOpenEditStoryDialog(true),
        },
        [Entity.useCase]: {
          api: getSingleUseCase_API,
          setData: setCurrentUseCaseData,
          openDialog: () => setOpenEditUseCaseDialog(true),
        },
        [Entity.testCase]: {
          api: getSingleTestCase_API,
          setData: setCurrentUseCaseData,
          openDialog: () => setOpenEditUseCaseDialog(true),
        },
      };

      if (entityMap[type]) {
        const response = await entityMap[type].api(
          {
            customIds: [customId],
            projectName: activeProject.name,
            folderPath,
          },
          handleSnackbar,
        );

        console.log(response.data, "single entity response");

        if (response.status === 200) {
          entityMap[type].setData(response.data);
          entityMap[type].openDialog();

          folder.toggle();
          if (folder?.id !== currentFolderData?.id) {
            setCurrentFolderData(folder?.data);
          }
        }

        return;
      }

      // Normal folder behavior
      folder.toggle();

      if (folder?.id !== currentFolderData?.id) {
        setCurrentFolderData(folder?.data);
      }

      if (openEditStoryDialog || openEditUseCaseDialog) {
        setOpenEditStoryDialog(false);
        setOpenEditUseCaseDialog(false);
      }
    } catch (error) {
      console.log(error, "error");
    }
  };

  const handleIconClick = (folder) => {
    folder.toggle();
    if (openEditStoryDialog || openEditUseCaseDialog) {
      setOpenEditStoryDialog(false);
      setOpenEditUseCaseDialog(false);
    }
  };

const handleRightClick = (event, folder) => {
  event.preventDefault();
  
  // Ensure folder data has path
  const folderDataWithPath = {
    ...folder?.data,
    path: folder?.data?.path || folder?.data?.name
  };
  
  if (folder?.id !== currentFolderData?.id) {
    setCurrentFolderData(folderDataWithPath);
  }
  
  setCurrentFolderAnchorCoordinates({
    mouseX: event.clientX + 2,
    mouseY: event.clientY - 6,
  });

  if (openEditStoryDialog || openEditUseCaseDialog) {
    setOpenEditStoryDialog(false);
    setOpenEditUseCaseDialog(false);
  }
};

  const handleFolderDoubleClick = (e) => {
    if (
      pathName === ModulePath.execution &&
      node?.data?.type?.toLowerCase() === Entity.release?.toLowerCase()
    ) {
      handleSnackbar(
        `Please navigate to Planning module to edit the Release`,
        Severity.info,
      );
      return;
    }

    e.stopPropagation();
    if (node?.data?.id !== currentFolderData?.id) {
      setCurrentFolderData(node?.data);
    }
    node.edit();
  };

  const handleDisableEdit = (e) => {
    e.stopPropagation();
    node.reset();
  };

  const handleSubmit = (e) => {
    if (e.target.value) {
      node.submit(e.target.value);
    }
  };

  const handleEditKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSubmit(e);
    }
  };

  const itemCount = getItemCount();
  const textColor = getCountTextColor();

  // Determine if we should show the count
  const shouldShowCount = () => {
    // Always return false if node type is UserStory, UseCase, TestCase
    if (
      [Entity.userStory, Entity.useCase, Entity.testCase].includes(
        node.data.type,
      )
    )
      return false;

    // Always show count for active items
    if (isActive) return true;

    // For non-active items, show based on module and type
    if (pathName === ModulePath.planning) {
      // For planning module, only show for non-release/sprint items
      return (
        node?.data?.type?.toLowerCase() !== Entity.release?.toLowerCase() &&
        node?.data?.type?.toLowerCase() !== Entity.sprint?.toLowerCase()
      );
    }

    // For other modules, always show
    return true;
  };

  return (
    <Box className="flex w-full relative">
      <Box
        className={`flex-1 flex items-center gap-1 py-1 px-2 cursor-pointer overflow-hidden`}
        borderRadius={theme.shape.borderRadius}
        sx={{
          backgroundColor: isActive ? "hsl(var(--accent))" : "transparent",
          color: isActive ? "hsl(var(--accent-foreground))" : "inherit",
          pl: node.level * 7,
          "&:hover": {
            backgroundColor: isActive
              ? "hsl(var(--accent))"
              : "hsl(var(--muted))",
            color: isActive
              ? "hsl(var(--accent-foreground))"
              : "hsl(var(--muted-foreground))",
          },
        }}
        onContextMenu={(e) => handleRightClick(e, node)}
      >
        {/* arrow icon container */}
        <Box className="" onClick={() => handleIconClick(node)}>
          {!node.isLeaf && (
            <Box
              className={`flex ${node.level === 0 ? "ml-2" : ""}`}
              borderRadius={theme.shape.borderRadius}
            >
              {node.isOpen ? <KeyboardArrowDown /> : <KeyboardArrowRight />}
            </Box>
          )}
        </Box>

        {/* folder detail container */}
        <Box
          className="flex-1 flex items-center gap-1 overflow-hidden"
          sx={{ pl: node.level * 4, px: node.isEditing && 0.2 }}
        >
          {node.isEditing ? (
            <>
              <input
                style={{ width: "100%" }}
                autoFocus
                defaultValue={node.data.name}
                onBlur={handleDisableEdit}
                onKeyDown={handleEditKeyDown}
              />
              <Close onClick={handleDisableEdit} />
            </>
          ) : (
            <Box
              className={`flex-1 flex items-center gap-1 overflow-hidden`}
              onDoubleClick={handleFolderDoubleClick}
              onClick={() => handleFolderClick(node)}
            >
              {node.data.type === FolderType.project && (
                <FolderSpecialOutlined />
              )}
              {node.data.type === FolderType.module && <FolderOutlined />}

              {node.data.type === Entity.userStory && <UserStoryCustomIcon />}
              {node.data.type === Entity.useCase && <UseCaseCustomIcon />}
              {node.data.type === Entity.testCase && <TestCaseCustomIcon />}

              <LightTooltip
                title={
                  <Box
                    className="flex flex-col gap-1"
                    sx={{
                      color: isActive
                        ? isDarkMode
                          ? "#fff"
                          : "#000"
                        : "inherit",
                    }}
                  >
                    <Typography fontSize={font.size.fs_6} color="inherit">
                      {t("title")}:{" "}
                      {[
                        Entity.userStory,
                        Entity.useCase,
                        Entity.testCase,
                      ].includes(node.data.type)
                        ? node.data.title
                        : node.data.name}
                    </Typography>
                    {/* Show all counts in tooltip for completeness */}
                    {pathName === ModulePath.requirements &&
                      ![
                        Entity.userStory,
                        Entity.useCase,
                        Entity.testCase,
                      ].includes(node.data.type) && (
                        <Typography fontSize={font.size.fs_6} color="inherit">
                          User Stories: {itemCount || 0}
                        </Typography>
                      )}
                    {pathName === ModulePath.useCase &&
                      ![
                        Entity.userStory,
                        Entity.useCase,
                        Entity.testCase,
                      ].includes(node.data.type) && (
                        <Typography fontSize={font.size.fs_6} color="inherit">
                          Use Cases: {itemCount || 0}
                        </Typography>
                      )}
                    {(pathName === ModulePath.execution ||
                      pathName === ModulePath.testCase) &&
                      ![
                        Entity.userStory,
                        Entity.useCase,
                        Entity.testCase,
                      ].includes(node.data.type) && (
                        <Typography fontSize={font.size.fs_6} color="inherit">
                          Test Cases: {itemCount || 0}
                        </Typography>
                      )}
                    {pathName === ModulePath.planning &&
                      node?.data?.type?.toLowerCase() ===
                        Entity.release?.toLowerCase() && (
                        <Typography fontSize={font.size.fs_6} color="inherit">
                          Sprints: {node?.data?.sprintCount || 0}
                        </Typography>
                      )}
                    {pathName === ModulePath.execution &&
                      node?.data?.type?.toLowerCase() ===
                        Entity.release?.toLowerCase() && (
                        <Typography fontSize={font.size.fs_6} color="inherit">
                          Test Sets: {node?.data?.testSetCount || 0}
                        </Typography>
                      )}
                  </Box>
                }
                placement="right"
              >
                <Box className="flex-1 flex items-center gap-2 min-w-0">
                  <Typography
                    className="flex-1 overflow-hidden text-ellipsis whitespace-nowrap"
                    fontWeight={500}
                    sx={{ color: "inherit" }}
                  >
                    {[
                      Entity.userStory,
                      Entity.useCase,
                      Entity.testCase,
                    ].includes(node.data.type)
                      ? node.data.customId
                      : node.data.name}
                  </Typography>

                  {/* Visible item count badge with brackets */}
                  {shouldShowCount() && (
                    <Box className="flex items-center gap-1 flex-shrink-0">
                      <Typography
                        sx={{
                          color: textColor,
                          fontSize: "0.75rem",
                          fontWeight: isActive ? 700 : 600,
                          fontFamily: "monospace",
                          opacity: itemCount === 0 ? 0.6 : 1,
                          minWidth: itemCount > 9 ? "28px" : "22px",
                          textAlign: "center",
                          letterSpacing: "0.5px",
                          // Add a slight text shadow for better contrast when active
                          textShadow: isActive
                            ? "0 1px 1px rgba(0,0,0,0.1)"
                            : "none",
                        }}
                      >
                        {itemCount}
                      </Typography>
                    </Box>
                  )}
                </Box>
              </LightTooltip>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
});
